import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-capsule', 'ArrowCapsule', [["path",{"d":"M18 15a6 6 0 1 1 -12 0v-6a6 6 0 1 1 12 0v2"}],["path",{"d":"M15 8l3 3l3 -3"}]]);